var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserQuestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.054,
    height: 227.78,
    viewBox: "0 0 98.054 227.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-questions",
    transform: "translate(-229.471 -0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M336.855,280.847a28.662,28.662,0,1,1-28.662-28.662,28.663,28.663,0,0,1,28.662,28.662",
    transform: "translate(-29.697 -149.598)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M335.349,194.61c-12.068,0-11.314-16.593,0-16.593S346.663,194.61,335.349,194.61Z",
    transform: "translate(-57.608 -105.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M277.68,25.653C280.7.008,316.9-10.552,331.987,13.585c13.577,20.365-13.577,33.188-17.348,40.729-3.017,5.28-1.508,12.822-9.05,12.822-10.56,0-8.3-15.085-1.508-22.628,6.035-6.788,23.382-16.593,12.068-27.153-4.525-4.525-18.1-6.788-22.628,9.05-3.772,11.314-15.84,6.788-15.84-.755Z",
    transform: "translate(-28.6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M261.149,394.97c-28.662,5.28-31.678,14.33-31.678,67.128h98.054c0-52.8-3.017-61.848-32.433-67.128,9.05,9.8-42.238,9.8-33.942,0Z",
    transform: "translate(0 -234.304)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserQuestions);
export default __webpack_public_path__ + "static/media/user-questions.6646b62eb2fb59c24465e0d919067190.svg";
export { ForwardRef as ReactComponent };